export const enum PopupVisibleStateEnum {
    closed = 'closed',
    closing = 'closing',
    open = 'open',
    opening = 'opening',
}
